export default {
  LIST(state, payload) {
    state.items = payload.results || payload
    state.total = payload.count || state.items.length
  },
}
